import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  select(event) {
    const card = event.currentTarget
    const assetId = event.params.id
    const filename = event.params.filename

    // Toggle selected state
    this.element.querySelectorAll(".media-picker-item").forEach(el => {
      el.classList.remove("border-primary", "border-2")
    })
    card.classList.add("border-primary", "border-2")

    // Set hidden field on closest form
    const form = this.element.closest("form") || document.querySelector(".content-block-form")
    if (form) {
      const hiddenField = form.querySelector("[name*='media_asset_id']")
      if (hiddenField) hiddenField.value = assetId
    }

    // Show selection indicator
    const indicator = document.getElementById("library-selection")
    if (indicator) {
      indicator.textContent = `Selected: ${filename}`
      indicator.classList.remove("d-none")
    }
  }
}
